module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "recipe-item",
    attrs: {
      "to": {
        name: 'RecipeDetail',
        params: {
          id: _vm.recipe.id
        }
      }
    }
  }, [_c('mu-card', [_c('div', {
    class: 'imgLoadContainer' + '_' + _vm.uid,
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageLoaded),
      expression: "!imageLoaded"
    }],
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAD6CAQAAAAlrtnPAAAB2UlEQVR42u3TMQEAAAgDINc/9Lw9bAAdSDvAI4KAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAggCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAgIIggIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAggCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCAgiCAgCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAlwLZBnzFqLt6FUAAAAASUVORK5CYII="
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoSmallUri != null && _vm.imageLoaded),
      expression: "recipe.photoSmallUri != null && imageLoaded"
    }],
    attrs: {
      "alt": _vm.recipe.title + ' image',
      "src": _vm.recipe.photoSmallUri,
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoSmallUri == null && _vm.imageLoaded),
      expression: "recipe.photoSmallUri == null && imageLoaded"
    }],
    attrs: {
      "alt": 'Empty image',
      "src": "static/emptyImgPlaceholder.png",
      "width": "100%"
    }
  }), _vm._v(" "), (!_vm.imageLoaded) ? _c('img', {
    staticStyle: {
      "margin": "0px auto",
      "position": "absolute",
      "height": "32px",
      "width": "32px",
      "vertical-align": "middle",
      "align-items": "center",
      "display": "flex",
      "text-align": "center",
      "align-content": "center",
      "top": "50%",
      "left": "calc(50% - 16px)"
    },
    attrs: {
      "src": "static/rollingSpinner.gif"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipe.video_url !== null) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "8px",
      "right": "8px"
    }
  }, [_c('mu-chip', [_c('mu-icon', {
    staticStyle: {
      "padding-top": "4px",
      "padding-bottom": "4px"
    },
    attrs: {
      "value": "ondemand_video"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "margin-top": "-6px"
    }
  }, [_c('div', {
    staticClass: "overflowText recipeCardTitle",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v(_vm._s(_vm.recipe.title))]), _vm._v(" "), (_vm.recipe.categories.length > 0) ? _c('div', {
    staticClass: "overflowText",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, _vm._l((_vm.recipe.categories), function(tag, i) {
    return _c('span', {
      key: 'recipe-' + i,
      attrs: {
        "title": tag
      }
    }, [_vm._v(_vm._s(tag)), (_vm.recipe.categories.length - 1 !== i) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.recipe.categories.length === 0) ? _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_vm._v("No categories")]) : _vm._e(), _vm._v(" "), _c('mu-chip', {
    staticClass: "carbTag",
    attrs: {
      "color": "#4479C9",
      "background-color": "white"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.oneCarbPortion.toFixed(0) + 'g') + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "timeTag",
    attrs: {
      "background-color": "white"
    }
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.recipe.totalTime * 60000)))]), _vm._v(" "), _c('recipe-rating', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "read-only": true,
      "rating": _vm.recipe.rating.ratingScore,
      "count": _vm.recipe.rating.ratingCount,
      "recipe": _vm.recipe
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a523fb96","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Components/RecipeCard.vue
// module id = 3274
// module chunks = 1